import React from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, HeroBg, HeroBgAr, Whatsapp, WhatsAppCtnt, WhatsIcon, WhatsIconBtn } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, ButtonWithIcon2, ContactButton, ContactButtonHref } from '../../../ui/CustomElements'
import { trackSnapWhatsAppClick, waMessage } from '../../../services/snapPixel'
const Banner = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966560532519';
        const message = waMessage();
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        trackSnapWhatsAppClick('banner');
        window.open(whatsappURL, '_blank');
    };
    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid'  id='home'>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} className="pb-5 bannerColMain">
                            <Box className='bannerContent'>
                                
                                <MainHeading className='main-heading' size="" color="var(--secondaryColor)">
                                    {t('designInspire')}
                                </MainHeading>
                                <MainHeading className='main-heading mb-3' size="" color="">
                                    {t('SpaceYourStory')}
                                </MainHeading>
                                <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap'>
                                    <ContactButtonHref href='tel:+966560532519' icon={ArrowBtn} label={t('CallUs')} />
                                    {/* <WhatsAppCtnt className='drWhatsBtn cursor-pointeer' onClick={WhatsApp} /> */}
                                    <ButtonWithIcon2 className='drWhatsBtn cursor-pointeer' bg="#25D366" icon={WhatsIconBtn} label={t('whatsapp')} onClick={WhatsApp} />
                                    
                                </SpanStyled>
                                
                            </Box>
                            

                        </Col>
                        
                    </Box>
                </Container>
            </BannerWapper>
        </>
    )
}
const BannerWapper = styled.section`
    padding-bottom: 2px;
    
    /* height: 745px; */
    padding-top: 100px;
    & > .container{
        .bannerColMain{
            height: 645px;
            background-image: url(${HeroBg});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: left center;
            border-radius: 16px;
            overflow: hidden;
            .bannerContent{
                display: flex;
                width: 630px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-top: 107px;
                padding-left: 168px;
                
            }
        }
        
    }
    .bannerRow{
        padding: 0px 0px 0 0px;
        align-items: center;
        margin-left: 0;
        margin-right: 0;
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    body.rtl &{
        & > .container{
            .bannerColMain{
                background-image: url(${HeroBgAr});
                background-position: right center;
                .bannerContent{
                    padding-top: 150px;
                    padding-left: 0;
                    padding-right: 168px;
                    
                }
            }
        }
            
        
        .bannerRow{
            padding: 0px 0px 0 0px;
            align-items: center;
            
        }
        
        .bannerCol1{
            padding-bottom: 60px !important;
        }
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
                
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        /* .main-heading{
            font-size: 55px;
        } */
    }
    @media (max-width: 991px) {
        padding-top: 84px;
        height: auto;
        /* .main-heading{
            font-size: 45px;
            text-align: center;
        } */
        .bannerSubTxt{
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .bannerSubDetailTxt{
            text-align: center;
            display: inline-block;
        }
        .bannerImgContainer{
            justify-content: center !important;
            padding-top: 0px;
        }
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        body.rtl &{
            
            .bannerSubTxt{
                font-size: 26px;
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .bannerColMain{
                height: 440px;
                background-size: 1190px 510px;
                background-position: left -40px top -10px;
                .bannerContent{
                    width: 100%;
                    padding-top: 50px;
                    padding-left: 90px;
                }
            }
        }
        body.rtl &{
            & > .container{
                .bannerColMain{
                    background-image: url(${HeroBgAr});
                    background-size: 1190px 510px;
                    background-position: right -120px top -10px;
                    .bannerContent{
                        padding-top: 70px;
                        padding-right: 9px;
                        
                    }
                }
            }
             
        }
    }
    @media (max-width: 640px) {
        padding-top: 80px;
        body.rtl &{
            .main-heading{
                font-size: 35px;
            }
            .bannerSubTxt{
                font-size: 24px;
            }
        }
    }
    @media (max-width: 575px) {
        & > .container{
            .bannerColMain{
                background-position: left -110px top -10px;
                .bannerContent{
                    width: 100%;
                    padding-top: 50px;
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }
        }
    }
    @media (max-width: 350px) {
        & > .container{
            .bannerColMain{
                .bannerContent{
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
`
export default Banner
